import { createFileRoute } from "@tanstack/react-router";
import { QaPage, qaJsonLd } from "@/components/QaPage";
import { breadcrumbJsonLd } from "@/lib/seo-jsonld";
import { LAST_REVIEWED } from "@/lib/official-sources";

const QUESTION = "Vad är PBI-kretsen?";
const SHORT_ANSWER = "PBI = Personer med Betydande Inflytande. Det är de personer i ett bolag eller en verksamhet som har sådan ställning att de ska prövas för personlig och ekonomisk lämplighet.";

export const Route = createFileRoute("/fraga/vad-ar-pbi-kretsen")({
  component: () => (
    <QaPage
      breadcrumbs={[
        { label: "Hem", to: "/" },
        { label: "Frågor & svar", to: "/fraga" },
        { label: "Vad är PBI-kretsen" },
      ]}
      question={QUESTION}
      shortAnswer={SHORT_ANSWER}
      body={"I PBI-kretsen ingår vanligen ägare med mer än 10–20% av aktierna, styrelseledamöter, VD, firmatecknare och i vissa fall finansiärer eller hyresvärdar med starkt inflytande. Alla i kretsen prövas enskilt."}
      source={{ label: "Folkhälsomyndigheten – Serveringstillstånd (vägledning)", href: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/tillsynsvagledning-enligt-alkohollagen/serveringstillstand/" }}
      extraSources={[]}
      deepGuide={{ to: "/pbi-krets", label: "PBI-kretsen – komplett förklaring" }}
      related={[{"to": "/fraga/kan-mitt-tillstand-aterkallas", "label": "Kan mitt serveringstillstånd återkallas?"}, {"to": "/fraga/vad-skiljer-erinran-fran-varning", "label": "Vad är skillnaden mellan erinran och varning?"}, {"to": "/fraga/vad-betyder-personlig-lamplighet", "label": "Vad betyder personlig lämplighet enligt alkohollagen?"}]}
      lastReviewed={LAST_REVIEWED}
    />
  ),
  head: () => ({
    meta: [
      { title: "Vad är PBI-kretsen?" },
      { name: "description", content: "PBI = Personer med Betydande Inflytande. Det är de personer i ett bolag eller en verksamhet som har sådan ställning att de ska prövas för personlig och ekono…" },
      { property: "og:title", content: QUESTION },
      { property: "og:description", content: SHORT_ANSWER },
      { property: "og:url", content: "https://alkoholprovet.se/fraga/vad-ar-pbi-kretsen" },
    ],
    links: [{ rel: "canonical", href: "https://alkoholprovet.se/fraga/vad-ar-pbi-kretsen" }],
    scripts: [
      qaJsonLd({
        url: "https://alkoholprovet.se/fraga/vad-ar-pbi-kretsen",
        question: QUESTION,
        answer: SHORT_ANSWER,
      }),
      breadcrumbJsonLd([
        { label: "Hem", url: "https://alkoholprovet.se/" },
        { label: "Frågor & svar", url: "https://alkoholprovet.se/fraga" },
        { label: "Vad är PBI-kretsen", url: "https://alkoholprovet.se/fraga/vad-ar-pbi-kretsen" },
      ]),
    ],
  }),
});
